module.exports = __webpack_public_path__ + "static/nav-7a3ed19f0b2fe5f5dd52874b32e9a80c.jpg";